import { gql } from "@apollo/client";

export const ACCESS_KEY_QUERY = gql`
  query AccessKey($pageNumber: Int!) {
    appAccessKeys(pageNumber: $pageNumber) {
    totalCount
    records{
     status
     sysOS
      sysName
      key
      fingerprint
      activatedAt
      employeename
      platform
      release
      publicIp
      arch
}
    }
  }
`;
export const KEY_GENERATION_MUTATION = gql`
mutation GenerateKey($employeeId: String!, $sysName: String!, $sysOS: String!) 
{  
  KeyGenration(employeeId: $employeeId, sysName: $sysName, sysOS: $sysOS){
   
     status
     sysOS
      sysName
      key
      fingerprint
      activatedAt
      employeename
      platform
      release
      publicIp
      arch
}
  }
`;

export const REVOKE_ACCESS_KEY_MUTATION = gql`
  mutation RevokeAccessKey($key: String!) {
    revokeAccessKey(key: $key) {
      key
      status
      platform
      release
      publicIp
      arch
      fingerprint
      activatedAt
      employeename
    }
  }
`;
export const DELETE_ACCESS_KEY_MUTATION = gql`
  mutation DeleteAccessKey($key: String!) {
    deleteAccessKey(key: $key)
  }
`;

// export const RENEW_ACCESS_KEY_MUTATION = gql`
//   mutation RenewAccessKey($key: String!) {
//     renewAccessKey(key: $key)
//   }
// `;
